let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
let specialTaxCodeRegex = /^([A-Z]{6}[X]{10}|[A-Z]{6}[0-9]{2}[A-Z][X]{7}|[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[X]{5})$/g
let addressRegex = /^[°.0-9a-zA-Z\s,-/]+$/g;


export function checkEmail(email) {
	if (!email) {
		return true
	}
	if (email.length === 0) {
		return true
	}
	return email.match(emailRegex) !== null;
}

export function checkAddress(address) {
	if (!address) {
		return true
	}
	if (address.length === 0) {
		return true;
	}
	return address.match(addressRegex) !== null;
}

export function checkTaxCode(taxCode, none) {
	if (taxCode === undefined) {
		return false;
	}
	if (taxCode && taxCode.toUpperCase() === "XXXXXXXXXXXXXXXX") {
		return false;
	}
	if (taxCode && taxCode.match(specialTaxCodeRegex) !== null && none) {
		return true
	}
	if (taxCode && taxCode.length === 0 && none) {
		return true;
	}
	if (taxCode && taxCode.length === 0 && !none) {
		return false;
	}
	const tmpTaxCode = taxCode.toString().trim().toUpperCase();
	
	const evenMapPositions = {
		0: 0,
		1: 1,
		2: 2,
		3: 3,
		4: 4,
		5: 5,
		6: 6,
		7: 7,
		8: 8,
		9: 9,
		A: 0,
		B: 1,
		C: 2,
		D: 3,
		E: 4,
		F: 5,
		G: 6,
		H: 7,
		I: 8,
		J: 9,
		K: 10,
		L: 11,
		M: 12,
		N: 13,
		O: 14,
		P: 15,
		Q: 16,
		R: 17,
		S: 18,
		T: 19,
		U: 20,
		V: 21,
		W: 22,
		X: 23,
		Y: 24,
		Z: 25,
	};
	
	const oddMapPositions = {
		0: 1,
		1: 0,
		2: 5,
		3: 7,
		4: 9,
		5: 13,
		6: 15,
		7: 17,
		8: 19,
		9: 21,
		A: 1,
		B: 0,
		C: 5,
		D: 7,
		E: 9,
		F: 13,
		G: 15,
		H: 17,
		I: 19,
		J: 21,
		K: 2,
		L: 4,
		M: 18,
		N: 20,
		O: 11,
		P: 3,
		Q: 6,
		R: 8,
		S: 12,
		T: 14,
		U: 16,
		V: 10,
		W: 22,
		X: 25,
		Y: 24,
		Z: 23,
	};
	
	const restMap = {
		0: "A",
		1: "B",
		2: "C",
		3: "D",
		4: "E",
		5: "F",
		6: "G",
		7: "H",
		8: "I",
		9: "J",
		10: "K",
		11: "L",
		12: "M",
		13: "N",
		14: "O",
		15: "P",
		16: "Q",
		17: "R",
		18: "S",
		19: "T",
		20: "U",
		21: "V",
		22: "W",
		23: "X",
		24: "Y",
		25: "Z",
	};
	
	let startPosition = 1;
	
	if (tmpTaxCode.length === 16) {
		const sum = tmpTaxCode
			.substr(0, tmpTaxCode.length - 1)
			.split("")
			.map((char) => {
				const value =
					startPosition % 2 === 0
						? evenMapPositions[char]
						: oddMapPositions[char];
				startPosition++;
				return value;
			})
			.reduce((value, current) => value + current, 0);
		
		return restMap[sum % 26] === tmpTaxCode[tmpTaxCode.length - 1];
	}
	
	return false;
}
